import React, { useState, useEffect } from 'react';
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import { IoClose } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import BuildAccordion from './BuildAccordion';
import BuildTab from './BuildTab';
import { addbuildsheet, getbuildsheet, getbuildsheetdata } from "../../Api/buildsheetApi"
import { useHistory } from "react-router-dom";
import { getCurrentUser } from "../../Api/auth";
import { getremoteInquirydataApi } from "../../Api/iron"
import { getInventoryByType } from "../../Api/inventoryApi";
import { getsingleprescription } from "../../Api/iron"
import {   getPrescription } from "../../Api/prescriptionApis";

const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};

const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};

function BuildSheet() {


    const history = useHistory();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get('id');

    const [buildsheetnumber, setBuildSheetNumber] = useState(0);
    const [buildsheetdata, setBuildSheetData] = useState([]);
    const [userdata, setUserdata] = useState('');


    const [scrolled, setScrolled] = useState(false);

    const [buildApiCall, setBuildApiCall] = useState(0);

    console.log("buildsheetnumber", buildsheetnumber);

    const [buttonNames, setButtonNames] = useState([
        "Driver", "3 Wood", "5 Wood", "7 Wood", "9 Wood", "2 Hybrid",
        "3 Hybrid", "4 Hybrid", "5 Hybrid", "6 Hybrid", "7 Hybrid", "8 Hybrid",
        "1 Iron", "2 Iron", "3 Iron", "4 Iron", "5 Iron", "6 Iron",
        "7 Iron", "8 Iron", "9 Iron", "GW", "SW", "LW"
    ]);

    useEffect(() => {
        getDataById();
        getbuildSheetDataById();
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);

    const [selectedButtons, setSelectedButtons] = useState([]);

    // useEffect(() => {
    //     // Assuming apidata is passed as a prop and contains the array of objects
    //     const titlesToRemove = buildsheetdata.map(item => item.title);
    //     const filteredButtonNames = buttonNames.filter(name => !titlesToRemove.includes(name));
    //     setButtonNames(filteredButtonNames);
    // }, [buildsheetdata]);

    const handleButtonClick = (index, name) => {
        if (selectedButtons.includes(index)) {
            setSelectedButtons(selectedButtons.filter(i => i !== index));
        } else {
            setSelectedButtons([...selectedButtons, index]);
        }
        setButtonNames(buttonNames.filter((_, i) => i !== index));

        const data = {
            builsheetnumber: name,
            project_id: id,
            user_id: userdata._id,
            fitter_name: userdata.firstname + " " + userdata.lastname,
        }

        addbuildsheet(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                // handleClose();
                getDataById();
                getbuildSheetDataById();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
        });
    };

    const getDataById = () => {
        getbuildsheet({ id: id }).then((res) => { 
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildSheetNumber(Data);
            } else {
                // alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const getbuildSheetDataById = () => {
        getbuildsheetdata({ id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildSheetData(Data);
            } else {
                // alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
        if (buildApiCall !== 0) {
            getbuildSheetDataById();
        }
    }, [buildApiCall])

    useEffect(() => {
        if (buildsheetnumber !== 0 && buildsheetnumber !== null && buildsheetnumber.length !== 0) {
            const newUrl = `/project/buildsheet/buildsheet-view/${id}`;
            history.push(newUrl); // Change URL without reloading the page
        }
    }, [buildsheetnumber, history]);

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        getRemortFittingDataById();
        getallmakedata(0);
        getprescriptionDataById();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);

    const [remortFittingFormData, setRemortFittingFormData] = useState(initData);


    const getRemortFittingDataById = () => {
        getremoteInquirydataApi({ id: id }).then((res) => {
            if (res?.code === 200) {
                const userData = res.data.data;
                console.log("userData", userData);
                setRemortFittingFormData(userData);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
    }, [remortFittingFormData]);

    
    const [allMakeData, setallMakeData] = useState([]);
    const getallmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByType(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setallMakeData(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const [SinglePrescription ,setSinglePrescription] = useState(0);
    const getprescriptionDataById = () => {
        getsingleprescription({ project_id: id }).then((res) => {
            if (res?.code === 200) {
                const prescriptionData = res.data.data;
                setSinglePrescription(prescriptionData);
            } else {
                // alert(res.data?.message);
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const [prescription, setPrescription] = useState(initialPrescriptionState);

    const getprescriptiondata = () => { 
        const data = {
            'project_id': id
        }
        getPrescription(data).then((res) => {
            if (!res.data.status) { 
                console.log(res.data.data[0].detail);
            } else { 
                setPrescription(res.data.data);
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    useEffect(() => {
        getprescriptiondata();
    }, []);

    return (
        <>
            {
                remortFittingFormData.firstname != "" ? (
                    <>
                        <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark add_club_modal">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">Add Club</h3>
                                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className='modal-select-btn'>
                                    <div className='select-btn-list'>
                                        {buttonNames.map((name, index) => (
                                            <div className='select-btn-item' key={index}>
                                                <button
                                                    type="button"
                                                    className={`btn btn-primary btn-select ${selectedButtons.includes(index) ? 'selected' : ''}`}
                                                    onClick={() => handleButtonClick(index, name)}
                                                >
                                                    {name}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>


                        <div className="main-page-body-content-header">
                            <HeaderAdmin />
                        </div>
                        <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec">
                            <div className="main-container">
                                <div className="main-page-body-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                <div className="sec-dashboard-header-title">
                                                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                        <h3>Build Sheet</h3>
                                                    </div>
                                                </div>
                                                <div className="dashboard-sec">
                                                    <div className="row">
                                                        <div className="col-md-8 dashboard_2 study_guide_open db_col">
                                                            {/* <div className="build_number_box">
                                                    <div className="build_number_box_inner">
                                                        <div className="build_title">
                                                            Build Number
                                                        </div>
                                                        <div className="build_number">
                                                            {buildsheetnumber?.number || 0}
                                                        </div>
                                                    </div>
                                                </div> */}
                                                            <BuildAccordion buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} />
                                                            <>
                                                                {buildsheetnumber === 0 ? (
                                                                    ""
                                                                ) : (
                                                                    // <div className="btn-box-section btn-inline-box">
                                                                    //     {/* <button className="btn btn-primary btn-remove">Remove Build</button>
                                                                    //     <button className="btn btn-primary btn-create">Save Build</button> */}
                                                                    // </div>
                                                                    <div></div>
                                                                )}
                                                            </>
                                                        </div>
                                                        <div className={`col-md-4 dashboard_first right_fix_sec ${scrolled ? 'tab_fix' : ''}`}>
                                                            <div className="fix_sec_view container-fluid ps-0">
                                                                <div className="btn-box-section mt-0">
                                                                    <button className="btn btn-primary btn-create" onClick={handleShow}>Add Club</button>
                                                                </div>
                                                                <BuildTab project_id={id} project_step="buildsheet" remortFittingFormData={remortFittingFormData} allMakeData={allMakeData} SinglePrescription={SinglePrescription} prescriptioncalc={prescription}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>) : (<> </>)
            }
        </>
    );
}

export default BuildSheet;